export enum VersionType {
  INITIAL = 'Initial',
  INTERMEDIATE = 'Intermediate',
  FINAL = 'Final',
  DUPLICATE = 'Duplicate',
  MANUAL = 'Manual',
  UNVERSIONED = 'Unversioned',
  BLANK = '',
}

export enum RuleVersionType {
  INITIAL = 'Initial',
  INTERMEDIATE = 'Intermediate',
  FINAL = 'Final',
  MANUAL = 'Manual',
  UNVERSIONED = 'Unversioned',
}

export enum DocumentAssociation {
  ExtractedData = 'extractedData',
  DocumentPages = 'documentPages',
  DocumentType = 'documentType',
  FieldValues = 'fieldValues',
  UserTasks = 'userTasks',
}
